/* eslint-disable no-use-before-define */

import React from "react";
import {
  Button as RNButton,
  Image,
  StyleSheet,
  Text,
  View,
} from "react-native";
import MenuButton from "../components/MenuButton";
import WebHeading from "../components/WebHeading";
import { RepositColours, RepositStyles } from "../utils/styles";
import goTo from "../utils/goTo";

export default class ReplaceInstall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
    };
  }
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Box Replacement",
  };

  render() {
    return (
      <View style={styles.wrapper}>
        <WebHeading title="Box Replacement" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ ...styles.bodyText, flex: 3 }}>
              <View style={{ flex: 3, justifyContent: "space-around" }}>
                <Text style={RepositStyles.headerText}>
                  Start a Reposit Box Replacement
                </Text>
                <Text style={RepositStyles.paragraphText}>
                  Ensure that the existing and replacement boxes have the same
                  serial number, and that the replacement box is powered on.
                </Text>
              </View>
              <View
                style={{
                  alignItems: "center",
                  flex: 4,
                  justifyContent: "center",
                }}
              >
                <Image
                  style={{ width: 300, height: 250 }}
                  resizeMode="contain"
                  source={require("../img/replace.png")}
                />
              </View>
              <View
                style={{
                  flexDirection: "column",
                  flex: 4,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <RNButton
                  title=" Next "
                  onPress={() => {
                    goTo(this.props.navigation, "SerialReplace");
                  }}
                  color={RepositColours.blue}
                />
                <Text style={RepositStyles.nextSub}>Confirm Serial Number</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "white",
    flex: 1,
  },
  heading: {
    marginHorizontal: 20,
    marginVertical: 20,
  },
  headingText: { fontSize: 32, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "center",
    fontSize: 24,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 40,
    marginVertical: 60,
  },
  bodyTextContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});



// WEBPACK FOOTER //
// ./src/containers/ReplaceInstall.js